import React, { useMemo, useState } from 'react';

import { connect } from 'react-redux';
import styled from 'styled-components';

import { parseNotificationsTimeline } from '../../utils/normalizers/notificationTimeline';
import MapFilter from '../molecules/MapFilter';
import MapSubtitles from '../molecules/MapSubtitles';
import RealTimeline from '../molecules/RealTimeline';
import StationMap from '../molecules/StationMap';

const StationMapFilterable = (props) => {
  const [activeMarker, setActiveMarker] = useState(false);
  const [selectedListChargePoint, setSelectedListChargePoint] = useState(false);
  const [searchText, setSearchText] = useState('');

  const {
    notifications: { notifications },
    allOriginChargePoints,
  } = props;

  const notificationsFiltered = useMemo(() => {
    if (selectedListChargePoint?.chargeBoxId) {
      if (notifications?.notificationList?.length) {
        return notifications.notificationList.filter(
          (notification) => notification.chargeBoxId === selectedListChargePoint?.chargeBoxId,
        );
      }
    }

    if (notifications?.notificationList?.length) {
      return notifications.notificationList;
    }

    return [];
  }, [notifications?.notificationList, selectedListChargePoint?.chargeBoxId]);

  return (
    <Div searchText={searchText}>
      <StationMap
        {...{
          activeMarker,
          chargePoints: allOriginChargePoints,
          setActiveMarker,
          selectedListChargePoint,
          setSelectedListChargePoint,
        }}
      />
      <Tools>
        <MapFilter
          {...{
            chargePoints: allOriginChargePoints,
            setActiveMarker,
            selectedListChargePoint,
            setSelectedListChargePoint,
            searchText,
            setSearchText,
          }}
        />
        {notificationsFiltered.length ? (
          <RealTimeline className='realtime' items={parseNotificationsTimeline(notificationsFiltered)} />
        ) : (
          <></>
        )}
      </Tools>
      <MapSubtitles />
    </Div>
  );
};

const mapStateToProps = (state) => {
  return {
    notifications: state.notifications,
    allOriginChargePoints: state.chargePoints.allOriginChargePoints,
  };
};

export default connect(mapStateToProps)(StationMapFilterable);

const Div = styled.div`
  width: 100%;
  position: absolute;
  display: flex;
  height: 100%;
  border-radius: 3px;

  .ant-skeleton {
    background-color: #fff;
    border-radius: 8px;
    padding: 5px;
  }

  .realtime {
    background-color: #fff;
    margin: 5px 0;
    padding: 20px 11px 0 10px;
    max-width: 300px;
    width: 100%;
    min-width: 250px;
    max-height: ${({ searchText }) => (searchText === '' ? '87%' : '55%')};
    height: auto;
    border-radius: 3px;
  }
`;
const Tools = styled.div`
  position: absolute;
  top: 60px;
  left: 10px;
  height: auto;
  max-height: 25%;
  display: flex;
  flex-direction: column;
  max-width: 300px;
  width: 100%;

  @media (min-width: 1025px) {
    max-height: 84%;
  }
`;
